export const version = "bignumber/5.0.8";
//# sourceMappingURL=_version.js.map